import React, {useState} from "react";
import { CustomerType } from "../../constants";
import GoogleLogo from "../../assets/icons/google-logo.png";
import Divider from "../Divider";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import NameInformation from "./NameInformation";
import EmailPhone from "./EmailPhone";
import LocationInformation from "./LocationInformation";
import {SignupUser} from "../../redux/auth/authSlice";
import SuccessModal from "../SuccessModal";

interface PropsI {
  nextPage: () => void;
  prevPage: () => void;
  selectedCustomerType: CustomerType.TPIN | CustomerType.RSA;
}

const SignupForm = ({ nextPage, prevPage, selectedCustomerType }: PropsI) => {
  const [formStep, setFormStep] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formValues, setFormValues] = useState({
    accountType: "RSA",
  })
  const dispatch = useAppDispatch();
  const { isSuccessful } = useAppSelector((state) => state?.auth);


  const submitForm = () => {
    dispatch(SignupUser(formValues)).then(res => {
        if(res.type === "signup/user/fulfilled"){
            setFormStep(0);
            setShowSuccessModal(true);
        }
    })
  };
  return (
      <div className="login_form signup">
          <SuccessModal
              showModal={showSuccessModal}
              onClose={()=>{setShowSuccessModal(false)}}
              note={"Your Onboarding process has been completed. A represenative of NLPCPFA would contact you shortly. Thank you"}
          />
        <h1 className="login_form_head">Sign up as a RSA customer</h1>
        <div className="login_form_text text-left">
          It’ll only take a few minutes.
        </div>
        <button className="btn btn-outline google-btn">
          <img src={GoogleLogo} alt="" className="pr-4"/>
          Sign up using Google
        </button>
        <Divider className="my-2" text="Or"/>
        <form>
          {formStep === 0 &&
              <NameInformation
                  prevPage={()=>prevPage()}
                  nextPage={(values) => {
                    setFormValues({...formValues, ...values});
                    setFormStep(1);
                  }}
              />
          }
          {formStep === 1 &&
              <EmailPhone
                  nextPage={(values) => {
                    setFormValues({...formValues, ...values});
                    setFormStep(2);
                  }}
                  prevPage={() => setFormStep(0)}
              />
          }
          {formStep === 2 &&
              <LocationInformation
                  prevPage={() => setFormStep(1)}
                  nextPage={(values)=>{
                      setFormValues({...formValues, ...values});
                      submitForm()
                  }}
              />
          }

        </form>
        <div className="signup_info">
          By confirming your email, you agree to our
          <Link to=""> Terms of Service </Link>
          and that you have read and understood our
          <Link to=""> Privacy Policy</Link>
        </div>
      </div>
  );
};
export default SignupForm;
